import intermind from '../../../index';
import { HistoryRecord, ListConfig, ListParams, ListResponse } from '../../../types';

export class HistoryResource {
  async listConfig(): Promise<ListConfig> {
    const { data } = await intermind.httpClient.get<ListConfig>(`/conferences/history/list-config`);
    return data;
  }

  async list(params: ListParams): Promise<ListResponse<HistoryRecord>> {
    const { data } = await intermind.httpClient.get<ListResponse<HistoryRecord>>(`/conferences/history`, {
      params,
    });
    return data;
  }

  async share(conferenceId: string): Promise<string> {
    const { data } = await intermind.httpClient.post(
      `/conferences/${conferenceId}/history/share`,
      {},
      {
        responseType: 'text',
      }
    );
    return data;
  }

  async import(token: string): Promise<HistoryRecord> {
    const { data } = await intermind.httpClient.post(`/conferences/history/import`, { token });
    return data;
  }
}
